import Vue from 'vue'
import '@/assets/iconfont/iconfont.css'
import './initComponent'
import './webim/IMListener.js'
import '@/util/update'
import store from './store/index'
import i18n from '@/i18n'
import App from './App.vue'
import router from './router'
import { addTrackGA4PageViewListener } from '@/util/GA4'
import { initCommonRouter } from '@/util/commonRouter'
Vue.config.productionTip = false
Vue.prototype.$commonRouter = initCommonRouter(router)

addTrackGA4PageViewListener(router)

Vue.prototype.$rootApp = new Vue({
  store,
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')
